module.exports = __webpack_public_path__ + "static/media/Increase_products.380a238e.png";